import type { ImgHTMLAttributes } from 'react';

export const LemonlightLogo = (props?: ImgHTMLAttributes<HTMLImageElement>) => {
  return <img {...props} src="/static/images/logo/lemonlight-logo.svg" />;
};
